// app/javascript/controllers/inline_edit_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["display", "input"]
    static values = {
        url: String,
        field: { type: String, default: "title" },
        wrapper: String  // e.g., "wiki_page" to send { wiki_page: { title: "..." } }
    }

    connect() {
        this.originalValue = this.inputTarget.value
    }

    edit(event) {
        event.preventDefault()
        event.stopPropagation()

        this.displayTarget.classList.add('hidden')
        this.inputTarget.classList.remove('hidden')
        this.inputTarget.focus()
        this.inputTarget.select()
    }

    save() {
        const newValue = this.inputTarget.value.trim()

        if (!newValue) {
            // Don't allow empty values, revert
            this.cancel()
            return
        }

        if (newValue === this.originalValue) {
            // No change, just close
            this.closeEdit()
            return
        }

        this.performSave(newValue)
    }

    async performSave(newValue) {
        try {
            const params = { [this.fieldValue]: newValue }
            const body = this.hasWrapperValue
                ? { [this.wrapperValue]: params }
                : params

            const response = await fetch(this.urlValue, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': this.csrfToken,
                    'Accept': 'application/json'
                },
                body: JSON.stringify(body)
            })

            if (!response.ok) {
                throw new Error('Save failed')
            }

            // Update display
            this.displayTarget.textContent = newValue
            this.originalValue = newValue
            this.closeEdit()

        } catch (error) {
            console.error('Save error:', error)
            this.inputTarget.classList.add('border-danger-500')
            setTimeout(() => {
                this.inputTarget.classList.remove('border-danger-500')
            }, 2000)
        }
    }

    cancel() {
        this.inputTarget.value = this.originalValue
        this.closeEdit()
    }

    closeEdit() {
        this.displayTarget.classList.remove('hidden')
        this.inputTarget.classList.add('hidden')
    }

    handleKeydown(event) {
        if (event.key === 'Enter') {
            event.preventDefault()
            this.save()
        } else if (event.key === 'Escape') {
            event.preventDefault()
            this.cancel()
        }
    }

    get csrfToken() {
        return document.querySelector("[name='csrf-token']")?.content || ''
    }
}
